<template>
  <div>
    <div class="event-header-prelive" v-if="!eventIsLive || selectedEvent.eventType ==='Virtual'">
      <div class="prelive-container">
        <div class="prelive-top-container">
          <div v-show="nonDesktopMode "
               class="prelive-back" @click="setSelectedEventNone">
            <v-icon>krypt-arrow-left</v-icon>
          </div>
          <div class="prelive-date-wrapper" v-show="selectedEvent.eventType !=='Virtual'">
            <!--            <span>Tuesday, 6 October 2020 19:45</span>-->
            <span>{{startDateFormatted}}</span>
          </div>
          <div class="prelive-date-wrapper" v-show="selectedEvent.eventType ==='Virtual'">
            <!--            <span>Tuesday, 6 October 2020 19:45</span>-->
            <span>{{$t('eventsList.ends')}} {{endDateFormatted}}</span>
          </div>
        </div>
        <div class="prelive-teams-wrapper" v-if="selectedEvent.eventType !=='Virtual'">
          <div class="prelive-team prelive-team-left">
            <span>{{selectedEvent.homeTeam}}</span>
          </div>
          <div class="prelive-icon-container" v-if="selectedEvent.bookingStatus === 'Booked'">
            <v-icon>krypt-live</v-icon>
          </div>
          <div class="no-live-separator" v-if="selectedEvent.bookingStatus !== 'Booked'">
            <span>&mdash;</span>
          </div>
          <div class="prelive-team prelive-team-right">
            <span>
              {{selectedEvent.awayTeam}}
            </span>
          </div>
        </div>
        <div class="prelive-teams-wrapper" v-if="selectedEvent.eventType ==='Virtual'">

          <div class="prelive-team ">
            <span>{{selectedEvent.name}}</span>
          </div>

        </div>
      </div>
    </div>
    <div v-show="eventIsLive && selectedEvent.eventType !=='Virtual'">
      <div class="live-top-container" v-bind:class="{'live-top-container-border':eventIsLive}">
        <div v-show="nonDesktopMode && eventIsLive && selectedEvent.eventType !=='Virtual'"
             class="live-back" @click="setSelectedEventNone">
          <v-icon>krypt-arrow-left</v-icon>
        </div>
        <div class="widget-scoreboard-placeholder-anchor"
             v-show="eventIsLive && selectedEvent.eventType !=='Virtual'">
          <div class="widget-scoreboard-placeholder">
            <v-img :src="this.isMobile ? ScoreboardMobilePlaceholder : ScoreboardPlaceholder"
            ></v-img>
          </div>
        </div>
        <div class="widget-scoreboard-wrapper">
          <div class="widget-scoreboard"
               v-show="eventIsLive && selectedEvent.eventType !=='Virtual'"></div>
        </div>
      </div>
      <div class="widget-top-wrapper live-top-container-border" v-show="!isMobileOrTablet">
        <div class="widget-momentum-placeholder"
             v-show="eventIsLive && selectedEvent.eventType !=='Virtual'">
          <v-img :src="this.isMobile ? MomentumMobilePlaceholder : MomentumPlaceholder"
          ></v-img>
        </div>
        <div>
          <div class="widget-momentum"
               v-show="eventIsLive && selectedEvent.eventType !=='Virtual'"></div>
        </div>
      </div>
    </div>


    <div class="event-header-live"
         v-if="isMobileOrTablet && eventIsLive && selectedEvent.eventType !=='Virtual'">
      <div class="live-container">
        <LiveCenter>
        </LiveCenter>
      </div>

    </div>
    <v-expansion-panels :multiple="true" v-model="activePanels">
      <v-expansion-panel v-for="(marketGroup,index) in marketGroupsList" :key="index"
                         v-show="marketGroupsList.length > 0">
        <v-expansion-panel-header expand-icon="krypt-arrow-down">
          <span class="event-dropdown-title">{{marketGroup.name}}</span>
          <div class="bot-switch bot-turn-off-switch bets-tab-count outlined" @click="turnOffBot($event,selectedEvent.id)" v-if="
              botMarketsForTournament[marketGroup.cId] && botMarketsForTournament[marketGroup.cId].botActive && !marketGroup.botDisabled
              ">
            <span >{{$t('trader.bettingBot.turnOff')| removeDiacriticsFromUppercase}}</span>
          </div>
          <div class="bot-switch bot-turn-on-switch bets-tab-count outlined" @click="turnOnBot($event,selectedEvent.id)" v-if="
              botMarketsForTournament[marketGroup.cId] && botMarketsForTournament[marketGroup.cId].botActive && marketGroup.botDisabled
              ">
            <span >{{$t('trader.bettingBot.turnOn')| removeDiacriticsFromUppercase}}</span>
          </div>

          <div class="active-bot-indicator bets-indicator bets-tab-count" @click="setBotConfig($event,botMarketsForTournament[marketGroup.cId])" v-if="
              botMarketsForTournament[marketGroup.cId] && botMarketsForTournament[marketGroup.cId].botActive && !botMarketsForTournament[marketGroup.cId].botStopped
              ">
            <span >AB</span>
          </div>
          <div class="inactive-bot-indicator bets-indicator bets-tab-count" @click="setBotConfig($event,botMarketsForTournament[marketGroup.cId])" v-if="
              botMarketsForTournament[marketGroup.cId] && !botMarketsForTournament[marketGroup.cId].botActive
              ">
            <span >NB</span>
          </div>
          <div class="reseed-bot-indicator bets-indicator bets-tab-count" @click="setBotConfig($event,botMarketsForTournament[marketGroup.cId])" v-if="
              botMarketsForTournament[marketGroup.cId] &&
              botMarketsForTournament[marketGroup.cId].botStopped &&
              botMarketsForTournament[marketGroup.cId].botActive
              ">
            <span >RS</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="matched-header-contrainer">
            <div class="matched-amount-container">
              <div class="matched-amount-text">
                <span>{{$t('eventsList.matched')}}: </span>
              </div>
              <div class="matched-amount">
                <span>{{ userCurrency }}{{ calculateMarketGroupPositions(marketGroup.marketList) | numberWithCommasNoDecimals }}</span>
              </div>
            </div>
            <div class="odds-container-header odds-container-header-left">
              <span>Back</span>
            </div>
            <div class="odds-container-header">
              <span>Lay</span>
            </div>
          </div>
          <div class="event-dropdown-container">
            <template v-for="market in marketGroup.marketList">
              <div v-for="(runner) in market.runners"
                   class="runner-row"
                   no-gutters
                   v-bind:class="{'hide-runner':(market.status === 'INACTIVE' && false)}"
              >
                <template>
                  <div class="event-time-cell bordered-event-cell top-border-event-cell "

                  >
                    <v-icon
                      size="24"
                      color="#A0A3A5"
                    >
                      krypt-stats
                    </v-icon>


                  </div>
                  <div class="runner-info">
                    <div class="runner-name-wrapper">
                      <span class="runner-name-text">{{runner.name}}</span>
                    </div>
                    <div class="runner-open-positions">
                      <div class="runner-open-position " v-if="typeof runner.amount !== 'undefined'"
                           v-bind:class="[{
                        'runner-open-positions-neg-wrapper':runner.amount <0,
                        'runner-open-positions-pos-wrapper':runner.amount >=0,
                       }]"
                      >
                        <span>{{runner.amount <0 ? '-' : ''}}{{userCurrency}}{{Math.abs(runner.amount) | numberWithCommas}}</span>
                      </div>
<!--                      <div class="runner-open-position " v-if="!runner.amount && projectedPositions[runner.id]"-->

<!--                      >-->
<!--                        <span>0{{userCurrency}}</span>-->
<!--                      </div>-->

                      <div class="arrow-neg-wrapper" v-if="projectedPositions[runner.id]">
                        <div class="runner-open-position runner-open-positions-icon-wrapper">
                          <v-icon>krypt-arrow-right</v-icon>
                        </div>
                        <div class="runner-open-position "
                             v-bind:class="[{
                        'runner-open-positions-neg-wrapper':projectedPositions[runner.id].amount <0,
                        'runner-open-positions-pos-wrapper':projectedPositions[runner.id].amount >=0,
                       }]"
                        >
                          <span>{{projectedPositions[runner.id].amount <0 ? '-' : ''}}{{userCurrency}}{{Math.abs(projectedPositions[runner.id].amount) | numberWithCommas}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-bind:class="{'event-disabled':(market.status === 'SUSPENDED' || runner.active === false || market.status === 'INACTIVE' || (!appIsOnline || isInLockDown)  || (!backendConnectionEstablished) || (!feedMap[selectedEvent.feed]))}"
                    class="bordered-event-cells-wrapper">

                    <div
                      v-if="market.status === 'SUSPENDED' && (appIsOnline && !isInLockDown)  && (backendConnectionEstablished)  && (feedMap[selectedEvent.feed]) "
                      class="event-overlay-absolute">
                      <div class="event-overlay-content">
                        <span class="suspended-text">{{$t('overlays.suspended')| removeDiacriticsFromUppercase}}</span>
                      </div>
                    </div>
                    <div
                      v-if=" market.status === 'INACTIVE' || (runner.active === false && market.status !== 'SUSPENDED') || (!appIsOnline || isInLockDown)  || (!backendConnectionEstablished) || (!feedMap[selectedEvent.feed])"
                      class="event-overlay-absolute">
                      <div class="event-overlay-content">
                        <span class="inactive-text">{{$t('overlays.inactive')| removeDiacriticsFromUppercase}}</span>
                      </div>
                    </div>
                    <div
                      class="bordered-event-cell event-odds-cell top-border-event-cell">
                      <!-- col="1" -->
                      <div class="odds-wrapper">


                        <div class="odds-row">
                          <div
                            v-show="!isMobilePortrait"
                            class="odd-cell">
                            <kryptButton color="default"
                                         @click.native="addBetEntry(
                                         runner.id,
                                         runner.layOdds && runner.layOdds.length > 2 && Math.trunc(runner.layOdds[2].stake) !== 0? runner.layOdds[2].odds: '',
                                         'back',
                                         market,
                                         runner.name
                                         )"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.layOdds && runner.layOdds.length > 2 && Math.trunc(runner.layOdds[2].stake) !== 0? runner.layOdds[2].odds: '')}"
                                         :displayedText="runner.layOdds && runner.layOdds.length > 2 && Math.trunc(runner.layOdds[2].stake) !== 0? runner.layOdds[2].odds: ''">

                            </kryptButton>
                            <div class="odds-subtext">
                              <div class="odds-subtext">
                             <span>{{runner.layOdds && runner.layOdds.length > 2 ?
                               `${$store.state.userCurrency}${Math.trunc(runner.layOdds[2].stake)}` : ''}}</span>
                              </div>
                            </div>
                          </div>
                          <div
                            v-show="!isMobilePortrait"
                            class="odd-cell">
                            <kryptButton color="default"
                                         @click.native="addBetEntry(runner.id,runner.layOdds && runner.layOdds.length > 1 && Math.trunc(runner.layOdds[1].stake) !== 0? runner.layOdds[1].odds: '',
                                         'back',
                                         market,
                                         runner.name)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.layOdds && runner.layOdds.length > 1 && Math.trunc(runner.layOdds[1].stake) !== 0? runner.layOdds[1].odds: '')}"
                                         :displayedText="runner.layOdds && runner.layOdds.length > 1 && Math.trunc(runner.layOdds[1].stake) !== 0? runner.layOdds[1].odds: ''">

                            </kryptButton>
                            <div class="odds-subtext">
                              <div class="odds-subtext">
                             <span>{{runner.layOdds && runner.layOdds.length > 1 ?
                               `${$store.state.userCurrency}${Math.trunc(runner.layOdds[1].stake)}` : ''}}</span>
                              </div>
                            </div>
                          </div>
                          <div
                            class="odd-cell">
                            <kryptButton color="superman"
                                         @click.native="addBetEntry(runner.id,runner.layOdds && runner.layOdds.length > 0 && Math.trunc(runner.layOdds[0].stake) !== 0? runner.layOdds[0].odds: '',
                                         'back',
                                         market,
                                         runner.name)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.layOdds && runner.layOdds.length > 0 && Math.trunc(runner.layOdds[0].stake) !== 0? runner.layOdds[0].odds: '&mdash;')}"

                                         :displayedText="runner.layOdds && runner.layOdds.length > 0 && Math.trunc(runner.layOdds[0].stake) !== 0? runner.layOdds[0].odds: '&mdash;'">

                            </kryptButton>
                            <div class="odds-subtext">
                             <span>{{runner.layOdds && runner.layOdds.length > 0 ?
                               `${$store.state.userCurrency}${Math.trunc(runner.layOdds[0].stake)}` : `${$store.state.userCurrency}0`}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="bordered-event-cell event-odds-cell top-border-event-cell">
                      <!-- col="1" -->
                      <div class="odds-wrapper odds-wrapper-lay">


                        <div class="odds-row">
                          <div
                            class="odd-cell">
                            <kryptButton color="lex-luthor"
                                         @click.native="addBetEntry(runner.id,runner.backOdds && runner.backOdds.length > 0 && Math.trunc(runner.backOdds[0].stake) !== 0? runner.backOdds[0].odds: '','lay',
                                         market,
                                         runner.name)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.backOdds && runner.backOdds.length > 0 && Math.trunc(runner.backOdds[0].stake) !== 0? runner.backOdds[0].odds: '&mdash;')}"

                                         :displayedText="runner.backOdds && runner.backOdds.length > 0 && Math.trunc(runner.backOdds[0].stake) !== 0? runner.backOdds[0].odds: '&mdash;'">

                            </kryptButton>
                            <div class="odds-subtext">
                              <span>{{runner.backOdds && runner.backOdds.length > 0 ?
                                `${$store.state.userCurrency}${Math.trunc(runner.backOdds[0].stake)}` : `${$store.state.userCurrency}0`}}</span>
                            </div>
                          </div>
                          <div
                            v-show="!isMobilePortrait"
                            class="odd-cell">
                            <kryptButton color="default"
                                         @click.native="addBetEntry(runner.id,runner.backOdds && runner.backOdds.length > 1 && Math.trunc(runner.backOdds[1].stake) !== 0? runner.backOdds[1].odds: '','lay',
                                         market,
                                         runner.name)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.backOdds && runner.backOdds.length > 1 && Math.trunc(runner.backOdds[1].stake) !== 0? runner.backOdds[1].odds: '')}"

                                         :displayedText="runner.backOdds && runner.backOdds.length > 1 && Math.trunc(runner.backOdds[1].stake) !== 0? runner.backOdds[1].odds: ''">

                            </kryptButton>
                            <div class="odds-subtext">
                              <span>{{runner.backOdds && runner.backOdds.length > 1 ?
                                `${$store.state.userCurrency}${Math.trunc(runner.backOdds[1].stake)}` : ''}}</span>
                            </div>
                          </div>
                          <div
                            v-show="!isMobilePortrait"
                            class="odd-cell">
                            <kryptButton color="default"
                                         @click.native="addBetEntry(runner.id,runner.backOdds && runner.backOdds.length > 1 && Math.trunc(runner.backOdds[2].stake) !== 0? runner.backOdds[2].odds: '','lay',
                                         market,
                                         runner.name)"
                                         :betInfo="{runnerId:runner.id, displayedText:(runner.backOdds && runner.backOdds.length > 2 && Math.trunc(runner.backOdds[2].stake) !== 0? runner.backOdds[2].odds: '')}"

                                         :displayedText="runner.backOdds && runner.backOdds.length > 2 && Math.trunc(runner.backOdds[2].stake) !== 0? runner.backOdds[2].odds: ''">

                            </kryptButton>
                            <div class="odds-subtext">
                              <span>{{runner.backOdds && runner.backOdds.length > 2?
                                `${$store.state.userCurrency}${Math.trunc(runner.backOdds[2].stake)}` : ''}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>


              </div>

            </template>

          </div>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <EmptyPage v-if="marketGroupsList.length ===0"></EmptyPage>
  </div>
</template>

<script>
import kryptButton from '@/components/other/kryptButton.vue';
import LiveCenter from '@/components/LiveCenter';
import EmptyPage from '@/components/EmptyPage';
import ScoreboardPlaceholder from '@/assets/utility/HeaderRow1Placeholder.svg';
import MomentumPlaceholder from '@/assets/utility/HeaderRow2Placeholder.svg';
import ScoreboardMobilePlaceholder from '@/assets/utility/HeaderRow1PlaceholderMobile.svg';
import MomentumMobilePlaceholder from '@/assets/utility/HeaderRow2PlaceholderMobile.svg';

const ScoreboardPlaceholderIconObj = new Image();
ScoreboardPlaceholderIconObj.src = ScoreboardPlaceholder;

const MomentumPlaceholderIconObj = new Image();
MomentumPlaceholderIconObj.src = MomentumPlaceholder;

const ScoreboardMobilePlaceholderIconObj = new Image();
ScoreboardMobilePlaceholderIconObj.src = ScoreboardMobilePlaceholder;

const MomentumMobilePlaceholderIconObj = new Image();
MomentumMobilePlaceholderIconObj.src = MomentumMobilePlaceholder;

export default {
  name: 'Event',
  data: function () {
    return {
      activePanels: [0, 1, 2, 3, 4],
      ScoreboardPlaceholder,
      MomentumPlaceholder,
      ScoreboardMobilePlaceholder,
      MomentumMobilePlaceholder
    };
  },
  components: {
    kryptButton: kryptButton,
    EmptyPage,
    LiveCenter,
  },
  methods: {
    turnOnBot:function (event,selectedEventId){
      event.stopPropagation();
      this.$store.dispatch('toggleBotForEvent',{id:selectedEventId,mode:'on'});
    },
    turnOffBot:function (event,selectedEventId){
      event.stopPropagation();
      this.$store.dispatch('toggleBotForEvent',{id:selectedEventId,mode:'off'});
    },
    setBotConfig:function(event,market){
      event.stopPropagation();
      this.$store.commit('setBotSport',this.selectedEvent.sportId);
      this.$store.commit('setBotCategory',this.selectedEvent.categoryId);
      this.$store.commit('setBotTournament',this.selectedEvent.tournamentId);
      this.$store.commit('setMarketsListForBettingBot',Object.values(this.botMarketsForTournament));
      this.$store.commit('setTraderActiveSection','bettingBot')
      this.$store.commit('toggleMyBetForBettingBotMobile')
      this.$store.commit('setBotConfig',market)
      this.$store.dispatch('getMarketBotConfig',market.id);

    },
    calculateMarketGroupPositions: function (markets) {
      try {
        if (markets) {
          return markets.reduce((totalVolume, market) => {
            return market.volume ? totalVolume + market.volume : totalVolume;
          }, 0);
        } else {
          return '';
        }

      } catch (e) {
        return '';
      }
    },
    addBetEntry: function (runnerId, odds, betType, market, runnerName) {
      let eventName = '~';
      if (this.selectedEvent.eventType !== 'Virtual') {
        eventName = `${this.selectedEvent.homeTeam} &ndash; ${this.selectedEvent.awayTeam}`;
      } else {
        eventName = this.selectedEvent.name;

      }
      let betId = window.uuidv4();

      this.$store.commit('addBet', {
        refId: betId,
        isValid: true,
        runnerId: runnerId,
        odds: odds.toString(),
        stake: '',
        keepBetOnLive: false,
        betType: betType,
        eventName: eventName,
        marketId: market.id,
        marketName: market.name,
        eventId: this.selectedEvent.id,
        runnerName: runnerName,
      });

      this.$store.commit('setActiveBetSection', 'betslip');
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    setCurrentView: function (section) {
      this.$store.commit('setLiveCenterActiveSection', section);
      this.$store.dispatch('getValidStreamInfo',
        {
          rid: (this.selectedEvent !== 'none' ? this.selectedEvent.remoteId : this.liveEvents[0].remoteId),
          streamId: (this.selectedEvent !== 'none' ? this.streamMappings[this.selectedEvent.remoteId] : this.liveEvents[0].streamId),
          event: (this.selectedEvent !== 'none' ? this.selectedEvent : this.liveEvents[0])
        });

    },
    setSelectedEventNone: function () {
      this.$store.commit('setSelectedEvent', 'none');
    }
  },
  watch: {
    selectedEvent: function (newEvent) {
      if (newEvent.status === 'Live' || newEvent.status === 'Interrupted' || newEvent.status === 'Suspended' || newEvent.status === 'Abandoned' || newEvent.status === 'Ended') {
        SIR('removeWidget', document.querySelector('.widget-scoreboard'));
        SIR('removeWidget', document.querySelector('.widget-momentum'));
        this.$nextTick(function () {
          SIR('addWidget', '.widget-scoreboard', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            disableAds: true,
            disablePitch: true,
            layout: 'single',
            disableComponents: true,
            scoreboard: 'extended',
            momentum: 'disable',
            tabsPosition: 'disable',
            matchId: newEvent.remoteId.replace('sr:match:', '')
          });
          SIR('addWidget', '.widget-momentum', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            disableAds: true,
            disablePitch: true,
            layout: 'single',
            disableComponents: true,
            tabsPosition: 'disable',
            momentum: 'extended',
            scoreboard: 'disable',
            matchId: newEvent.remoteId.replace('sr:match:', '')
          });
        });

      }
      if (newEvent.eventType === 'Virtual') {
        this.activePanels = [0, 1, 2];
      } else {
        this.activePanels = [0, 1, 2, 3, 4];
      }
    },
    eventIsLive: function (isLive) {
      if (isLive) {
        this.$nextTick(function () {
          SIR('addWidget', '.widget-scoreboard', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            disableAds: true,
            disablePitch: true,
            layout: 'single',
            disableComponents: true,
            scoreboard: 'extended',
            momentum: 'disable',
            tabsPosition: 'disable',
            matchId: this.selectedEvent.remoteId.replace('sr:match:', '')
          });
          SIR('addWidget', '.widget-momentum', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            disableAds: true,
            disablePitch: true,
            layout: 'single',
            disableComponents: true,
            tabsPosition: 'disable',
            momentum: 'extended',
            scoreboard: 'disable',
            matchId: this.selectedEvent.remoteId.replace('sr:match:', '')
          });
        });
      }
      ;
    },
    backendConnectionEstablished:function (isOnline){
      if(isOnline){
        if(this.selectedEvent?.id != null) {
          this.$store.commit('resubscribeForEventMarkets',this.selectedEvent);
        }
      }
    }
  },
  mounted: function () {
    this.scrollToTop();
    if (typeof this.selectedEvent.remoteId !== 'undefined' && this.selectedEvent.status === 'Live' || this.selectedEvent.status === 'Interrupted' || this.selectedEvent.status === 'Suspended' || this.selectedEvent.status === 'Abandoned' || this.selectedEvent.status === 'Ended') {
      if (this.selectedEvent.status === 'Live' || this.selectedEvent.status === 'Interrupted' || this.selectedEvent.status === 'Suspended' || this.selectedEvent.status === 'Abandoned' || this.selectedEvent.status === 'Ended') {
        this.$nextTick(function () {
          SIR('addWidget', '.widget-scoreboard', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            disableAds: true,
            disablePitch: true,
            layout: 'single',
            disableComponents: true,
            scoreboard: 'extended',
            momentum: 'disable',
            tabsPosition: 'disable',
            matchId: this.selectedEvent.remoteId.replace('sr:match:', '')
          });
          SIR('addWidget', '.widget-momentum', (this.shouldUseLMTLight?'match.lmtLight':'match.lmtPlus'), {
            disableAds: true,
            disablePitch: true,
            layout: 'single',
            disableComponents: true,
            tabsPosition: 'disable',
            momentum: 'extended',
            scoreboard: 'disable',
            matchId: this.selectedEvent.remoteId.replace('sr:match:', '')
          });
        });
      }

    }
  },
  computed: {
    botMarketsForTournament:function(){
      return this.$store.state.trader.bettingBot.marketsForTournament;
    },
    botMarketMakingTree: function () {
      return this.$store.state.trader.bettingBot.supportedSportsMap;
    },
    shouldUseLMTLight:function(){
      return this.selectedEvent.eventType ==='Match' && this.selectedEvent.sportIdentifier === 'cricket'
    },
    projectedPositions: function () {
      try {
        let newBetsList = this.$store.state.bets.betslip.betList;
        let projectedPositions = {};
        newBetsList.forEach(function (bet) {
          for (let i in this.$store.state.markets[bet.eventId].markets[bet.marketId].runners) {
            let currentRunnerId = this.$store.state.markets[bet.eventId].markets[bet.marketId].runners[i].id
            if (currentRunnerId === bet.runnerId) {
              //Runner for bet
              if (!projectedPositions.hasOwnProperty(bet.runnerId)) {
                projectedPositions[bet.runnerId] = { amount: 0 };
                if (this.$store.state.markets[bet.eventId].markets[bet.marketId].runners[i].hasOwnProperty('amount')) {
                  projectedPositions[bet.runnerId].amount = this.$store.state.markets[bet.eventId].markets[bet.marketId].runners[i].amount;
                }
              }
              if (bet.betType === 'back') {
                projectedPositions[bet.runnerId].amount += Number((Number(bet.odds) * Number(bet.stake)).toFixed(2));
                projectedPositions[bet.runnerId].amount = Number(projectedPositions[bet.runnerId].amount - bet.stake).toFixed(2);
              } else {
                projectedPositions[bet.runnerId].amount = Number((projectedPositions[bet.runnerId].amount - (bet.stake * (Number(bet.odds) - 1))).toFixed(2));
              }
            } else {
              //Runners not of bet
              if (!projectedPositions.hasOwnProperty(currentRunnerId)) {
                projectedPositions[currentRunnerId] = { amount: 0 };
                if (this.$store.state.markets[bet.eventId].markets[bet.marketId].runners[i].hasOwnProperty('amount')) {
                  projectedPositions[currentRunnerId].amount = this.$store.state.markets[bet.eventId].markets[bet.marketId].runners[i].amount;
                }
              }
              if (bet.betType === 'back') {
                projectedPositions[currentRunnerId].amount = Number(projectedPositions[currentRunnerId].amount - Number(Number(bet.stake).toFixed(2)));
              } else {
                projectedPositions[currentRunnerId].amount +=  Number(Number(bet.stake).toFixed(2));
              }
            }
          }
        }.bind(this));
        return projectedPositions;
      } catch (e) {
        console.log(e)
        return {};
      }

    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    isLoggedIn: function () {
      return this.$store.state.user.isLoggedIn;
    },
    appIsOnline: function () {
      return this.$store.state.appIsOnline;
    },

    isInLockDown:function (state,payload){
      return this.$store.state.isInLockdown;
    },
    nonDesktopMode: function () {
      return (this.$store.state.deviceMode !== 'desktop');
    },
    feedIsOnline: function () {
      return this.$store.state.feedStatus.list[this.selectedEvent.feed];
    },
    feedMap: function () {
      return this.$store.state.feedStatus.list.reduce((list, feed) => {
        return {
          ...list,
          [feed['feed']]: feed.healthy,
        };
      }, {})
      // return this.$store.state.feedStatus.reduce((list, feed) => (list[feed.feed] = feed.healthy), {})
    },
    backendConnectionEstablished: function () {
      return this.$store.state.backendConnectionEstablished;
    },
    startDateFormatted: function () {
      return (this.selectedEvent.start ? new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hourCycle: 'h23'
        }
      ).format(this.moment.utc(this.selectedEvent.start)
        .local()) : '');
    },
    endDateFormatted: function () {
      return (this.selectedEvent.end ? new Intl.DateTimeFormat(window.SelectedTimeLocalisation,
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }
      ).format(this.moment.utc(this.selectedEvent.end)
        .local()) : '');
    },
    isMobileOrTablet: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait' || this.$store.state.deviceMode === 'tablet');
    },
    isMobile: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait');
    },
    isMobilePortrait: function () {
      return (this.$store.state.deviceMode === 'mobile-landscape' || this.$store.state.deviceMode === 'mobile-portrait');
    },
    eventIsLive: function () {
      let event = this.selectedEvent;
      return (typeof event !== 'undefined' && (event.status === 'Live' || event.status === 'Interrupted' || event.status === 'Suspended' || event.status === 'Abandoned' || event.status === 'Ended'));
    },
    selectedEvent: function () {
      return this.$store.state.navigations.selectedEvent;
    },
    selectedEventMarkets: function () {
      return this.$store.state.markets[this.selectedEvent.id];
    },
    marketGroupsForEvent: function () {
      return this.$store.state.navigations.selectedEvent;
    },
    marketGroupsList: function () {
      let marketGroupsList = JSON.parse(JSON.stringify(this.marketsGrouped));
      for (let i in marketGroupsList) {
        marketGroupsList[i].marketList = Object.values(marketGroupsList[i].markets);
      }

      let marketsToReturn = Object.values(marketGroupsList)
        .sort(function (a, b) {
          if (this.selectedEvent !== 'none' && this.selectedEvent.eventType === 'Virtual') {
            let n = a.orderId - b.orderId;
            if (n !== 0) {
              return n;
            }

            return ('' + a.name).localeCompare(b.name);
          }
          return a.orderId - b.orderId;
        }.bind(this));
      for (let j in marketsToReturn) {
        marketsToReturn[j].marketList = marketsToReturn[j].marketList.sort(function (a, b) {
          if (a.specifier < b.specifier) {
            return -1;
          }
          if (a.specifier > b.specifier) {
            return 1;
          }
          // if(a.specifier === b.specifier){
          //   if (a.name < b.name) {
          //     return -1;
          //   }
          //   if (a.name > b.name) {
          //     return 1;
          //   }
          // }
          return 0;
        });
      }

      return marketsToReturn;

    },
    marketsGrouped: function () {
      let groupedMarkets = {};
      if (typeof this.selectedEventMarkets !== 'undefined') {
        for (let marketId in this.selectedEventMarkets.markets) {
          if (typeof groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId] === 'undefined') {
            groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId] = { markets: {} };
          }
          groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId].botDisabled = this.selectedEventMarkets.markets[marketId].botDisabled
          groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId].name = this.selectedEventMarkets.markets[marketId].name;
          groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId].cId = this.selectedEventMarkets.markets[marketId].cId;
          groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId].orderId = this.selectedEventMarkets.markets[marketId].orderId;
          groupedMarkets[this.selectedEventMarkets.markets[marketId].groupId].markets[marketId] = this.selectedEventMarkets.markets[marketId];
        }

      }

      return groupedMarkets;
    },
    isMobilePortrait: function () {
      return (this.$store.state.deviceMode === 'mobile-portrait');
    },
  }

};
</script>

<style scoped>
  .bot-switch {
    /*width: 80px;*/
    /*border-color:  var(--cyborg);*/
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin: -1px 16px -1px 8px;
    height: max-content;
    min-width: 68px!important;

  }
  .bot-turn-on-switch{
    border: thin solid var(--cyborg);
    color: white;
    background-color: var(--cyborg);

  }
  .bot-turn-off-switch{
    border: thin solid var(--cyborg);
    color: var(--cyborg);
  }
  .bot-switch > span{
    padding : 1px 8px!important;
    text-transform: uppercase;
  }

  span {
    line-height: 16px;
  }

  .event-dropdown-title {
    font-size: 12px;
    font-weight: 700;
    color: var(--grey-900);
    width: 100%;
  }

  .matched-header-contrainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-top: 1px var(--grey-200) solid;
    padding-left: 16px;
    /* padding-right: 8px; - not needed after adding 8px padding to the Lay container */
  }

  .matched-amount-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    padding: 8px 0;
  }

  .matched-amount-container > * {
    display: flex;
  }

  .matched-amount > span {
    color: var(--wonder-woman);
    font-size: 12px;
    font-weight: 700;
    padding-left: 2px;
  }

  .odds-container-header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(210px - 8px);
    padding: 8px;
    border-left: 1px var(--grey-200) solid;
  }

  .odds-container-header-left {
    width: 201px;
  }

  .odds-container-header > span {
    font-size: 12px;
    font-weight: bold;
    color: var(--grey-600);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .matched-amount-text > span {
    font-size: 12px;
    font-weight: normal;
    color: var(--grey-600);
  }

  .runner-row {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    border-top: 1px var(--grey-200) solid;
    max-height: 1000px;
  }

  .odds-wrapper {
    width: calc(203px - 8px);
  }

  .odds-wrapper-lay > .odds-row > .odd-cell:last-child {
    margin-right: 0 !important;
  }

  .odds-wrapper-lay {
    width: calc(199px - 8px);
  }

  .bordered-event-cells-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    border-left: 1px var(--grey-200) solid;
    position: relative;
  }

  .bordered-event-cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bordered-event-cell i:hover {
    color: var(--grey-600) !important;
    cursor: pointer;
  }

  .odds-row {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    padding: 8px 0;
  }

  .odd-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-right: 4px;
    overflow: hidden;
  }

  .odds-subtext {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 16px;
    overflow: hidden;
    width: 100%;
  }

  .odds-subtext > span {
    font-size: 12px;
    font-weight: 400;
    color: var(--grey-600);
    min-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .runner-info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-grow: 1;
    padding: 4px 0;
    padding-right: 16px;
  }

  .runner-open-positions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
  }

  .runner-open-position {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .runner-open-position:not(:last-child) {
    padding-right: 2px;
  }

  .runner-open-position span {
    overflow: hidden;
    white-space: nowrap;
  }

  .runner-open-positions-pos-wrapper span {
    font-size: 12px;
    font-weight: 700;
    color: var(--aquaman);
  }

  .runner-open-positions-neg-wrapper span {
    font-size: 12px;
    font-weight: 700;
    color: var(--cyborg);
  }

  .runner-open-positions-icon-wrapper .v-icon {
    font-size: 16px;
    color: var(--grey-500);
  }

  .runner-name-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  .runner-name-text {
    font-size: 14px;
    font-weight: 700;
    color: var(--grey-900);
    padding-bottom: 2px;
    /*text-transform: capitalize; -this makes capital the first letter of every work - we want the first letter only */
    line-height: 18px;
    max-height: 36px;
    overflow: hidden;
  }

  .runner-name-text::first-letter {
    text-transform: uppercase;
  }

  .event-time-cell {
    /* temporary disablement of chart icon
    padding: 0 16px; */
    padding: 0 16px 0 8px;
  }

  /* temporary disablement of chart icon */
  .event-time-cell >>> .v-icon {
    display: none;
  }

  .arrow-neg-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .event-header-prelive {
    width: calc(100% + 16px);
    margin-left: -8px;
  }

  .event-header-live {
    width: 100%;
    margin-top: 8px;
  }

  .prelive-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: white;
  }

  .live-containter {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: white;
    border-radius: 4px;
  }

  .prelive-date-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
  }

  .prelive-date-wrapper > span {
    font-weight: 400;
    color: var(--grey-600);
    font-size: 12px;
    line-height: 16px;
    padding: 8px 0;
    text-align: center;
  }

  .prelive-teams-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px var(--grey-200) solid;
    width: 100%;
    padding: 16px 0;
  }

  .prelive-team {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 50%;
    text-align: center;
    overflow: hidden;
  }

  .prelive-icon-container,
  .no-live-separator {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
  }

  /*  .prelive-icon-container:hover i {
      color: var(--grey-600);
      cursor: pointer;
    }*/

  .prelive-icon-container > i {
    width: 24px;
    height: 24px;
    color: var(--grey-400);
  }

  .no-live-separator > span {
    width: 24px;
    height: 24px;
    font-weight: bold;
    color: var(--grey-400);
    text-align: center;
    line-height: 24px;
  }

  .prelive-team > span {
    font-weight: 700;
    color: var(--grey-900);
    font-size: 16px;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .prelive-top-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .prelive-back {
    width: 48px;
    height: 48px;
    justify-content: center;
    align-items: center;
    display: flex;
    /* background: white; was creating a non-rounded corner on the top left */
  }

  .live-back {
    width: 48px;
    min-width: 48px; /* added because scorecard squeezes the div despite the width */
    height: 57px;
    justify-content: center;
    align-items: center;
    display: flex;
    background: white;
  }

  .widget-scoreboard-wrapper {
    width: 100%;
    height: 57px;
  }

  .prelive-back > i, .live-back > i {
    font-size: 32px;
    color: var(--grey-400) !important;
  }

  .prelive-back:hover > i, .live-back:hover > i {
    font-size: 32px;
    color: var(--grey-600) !important;
  }

  .live-score-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 8px;
    overflow: hidden;
  }

  .live-score-team, .live-score {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 100px;
  }

  .live-score-team {
    overflow: hidden;
  }

  .live-score-team > span {
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    color: var(--grey-500);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .live-score > span {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: var(--grey-900);
  }

  .mobile-video-icons {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .live-center-icons {
    padding: 0 8px;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .mobile-widgets {
    border-top: 1px var(--grey-200) solid;
  }

  .event-overlay-absolute {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    right: -50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 8px;
  }

  .event-overlay-content {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .event-overlay-content > span {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    overflow: hidden;
    text-align: center;
    text-transform: uppercase;
  }

  .event-disabled > *:not(:first-child) {
    opacity: 0.2;
  }

  .inactive-text {
    color: var(--grey-500);
  }

  .suspended-text {
    color: var(--wonder-woman);
  }

  .live-top-container {
    display: flex;
    justify-content: center;
    position: relative;
  }

  .live-top-container.live-top-container-border {
    border-bottom: 1px var(--grey-300) solid;
  }

  @media screen and (max-width: 1279px) {
    .widget-top-wrapper.live-top-container-border {
      border-bottom: 1px var(--grey-300) solid;
    }

    .live-top-container.live-top-container-border {
    border-bottom: 1px var(--grey-200) solid;
  }
  }


  .hide-runner {
    transition: max-height 60s step-end, visibility 60s step-end, border-top 60s step-end;
    max-height: 0px !important;
    visibility: hidden !important;
    border-top: 0px var(--grey-200) solid !important;
  }

  .event-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .widget-top-wrapper {
    /* overflow: hidden;*/
    height: max-content; /* was: 101px */
    min-height: 101px;
    position: relative;
  }

  .widget-scoreboard-placeholder-anchor, .widget-momentum-placeholder-anchor {
    display: flex;
    height: 100%;
  }

  .widget-scoreboard-placeholder {
    position: absolute;
    width: calc(100% - 48px);
    height: 57px;
    background-color: white;
  }

  .widget-momentum-placeholder {
    position: absolute;
    width: 100%;
    height: 101px;
    background-color: white;
  }

  .widget-scoreboard-placeholder > .v-image, .widget-momentum-placeholder > .v-image {
    height: 100%;
  }

  .widget-scoreboard-placeholder > .v-image > >>> .v-image__image,
  .widget-momentum-placeholder > .v-image > >>> .v-image__image {
    background-size: 100% 100%;
  }

  .widget-scoreboard-placeholder > >>> .v-image:after,
  .widget-momentum-placeholder > >>> .v-image:after {
    background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .3), hsla(0, 0%, 100%, 0));
    -webkit-animation: loading 1.5s infinite;
    animation: loading 1.5s infinite;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
  }

  .bets-tab-count > span {
    display: flex;
    align-items: center;
    text-align: center;
    user-select: none;
    line-height: 14px;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
  }

  .bets-tab-count.active-bot-indicator > span,
  .bets-tab-count.reseed-bot-indicator > span {
    color: white;
  }

  .bets-tab-count.inactive-bot-indicator > span {
    color: var(--grey-600)
  }

  .bets-tab-count.active-bot-indicator:hover {
    background-color: var(--lex-luthor);
  }

  .bets-tab-count.reseed-bot-indicator:hover {
    background-color: var(--cyborg-state);
  }

  .bets-tab-count.inactive-bot-indicator:hover {
    background-color: var(--grey-300-state);
  }

  .bets-tab-count {
    min-width: 20px;
  }

  .active-bot-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--aquaman);
    border-radius: 4px;
    margin: -1px 16px -1px 8px;
    height: max-content;
  }

  .inactive-bot-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-300);
    border-radius: 4px;
    margin: -1px 16px -1px 8px;
    height: max-content;
  }
  .reseed-bot-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--cyborg);
    border-radius: 4px;
    margin: -1px 16px -1px 8px;
    height: max-content;
  }

  /*Vuetify*/

  >>> .v-expansion-panel-header__icon i {
    color: var(--grey-900) !important;
  }

  >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }

  >>> .v-expansion-panel-header {
    min-height: inherit !important;
    padding: 8px !important;
    padding-left: 16px !important;
  }

  >>> .v-expansion-panel::before {
    box-shadow: 0 0 0 0 !important;
  }

  >>> .v-expansion-panel-header {
    outline: 0 !important;
  }

  >>> .v-expansion-panel-header::before {
    opacity: 0 !important;
  }

  /*Media Queries*/

  @media screen and (max-width: 630px) {
    .bordered-event-cells-wrapper {
      padding: 0 8px !important;
    }

    .odds-wrapper {
      width: 65px;
    }

    .odds-wrapper-lay {
      width: 61px !important;
    }

    .odds-container-header {
      width: 72px !important;
    }

    .odds-container-header-left {
      width: 71px !important;
    }

    .event-time-cell {
      padding-left: 8px !important;
    }

    .odds-wrapper-lay > .odds-row > .odd-cell:first-child {
      margin-right: 0px !important;
    }

    .runner-info {
      padding-right: 8px !important;
      overflow: hidden;
    }

    .prelive-teams-wrapper {
      padding: 16px 9px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media screen and (min-width: 1280px) {
    .event-header-prelive {
      width: 100% !important;
      margin-top: 8px !important;
      margin-left: 0px !important;
    }

    .widget-top-wrapper {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding-left: 4px;
      padding-right: 4px;
      background-color: white;
    }

    .widget-momentum-placeholder {
      width: calc(100% - 8px);
    }

    .prelive-container {
      border-radius: 4px !important;
    }

    .live-top-container {
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      overflow: hidden;
      margin-top: 8px;
    }
  }

  @media screen and (min-width: 1500px) {
    .widget-scoreboard-placeholder {
      width: 100% !important;
    }
  }

  @media screen and (min-width: 884px) and (max-width: 1279px) {
    .event-header-prelive {
      width: calc(100% + 32px) !important;
      margin-left: -16px;
    }
  }

  @media screen and (max-width: 883px) {
    .live-top-container, .widget-top-wrapper, .event-header-live {
      width: calc(100% + 16px);
      margin-left: -8px;
    }

    .event-header-live {
      margin-top: 0px;
    }
  }

  @media screen and (min-width: 884px) and (max-width: 1279px) {
    .live-top-container, .widget-top-wrapper, .event-header-live {
      width: calc(100% + 32px);
      margin-left: -16px;
    }

    .event-header-live {
      margin-top: 0px;
    }
  }

  /*Important Override*/

  .live-center-icons > i {
    color: var(--grey-400) !important;
  }

  .live-center-icons > i:hover {
    color: var(--grey-600) !important;
  }

  /*Animations*/

  @-webkit-keyframes loading {
    to {
      transform: translateX(100%)
    }
  }

  @keyframes loading {
    to {
      transform: translateX(100%)
    }
  }

</style>
